import { useEffect, useRef } from "react";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router";

import { clearStepUpPending, isStepUpPending } from "@/auth/stepUp";
import { STEP_UP_REQUEST } from "@/auth/userManager";
import { Spinner } from "@/components/Spinner";
import { Button } from "@/components/ui";

export function SignedOut() {
  const auth = useAuth();
  const navigate = useNavigate();
  // Décidé au premier rendu ; le drapeau est consommé par l'effet ci-dessous.
  const stepUp = useRef(isStepUpPending());

  useEffect(() => {
    // Relit le drapeau : en développement, StrictMode joue l'effet deux fois, et
    // la seconde ne doit pas relancer une connexion de plus.
    if (!isStepUpPending()) return;
    clearStepUpPending();
    void auth.signinRedirect(STEP_UP_REQUEST);
  }, []);

  if (stepUp.current) return <Spinner label="Confirming your identity…" />;

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="card max-w-md w-full text-center space-y-4">
        <h1 className="text-2xl font-semibold text-ink">Signed out</h1>
        <p className="text-sm text-ink-muted">
          You have been logged out of the PulseStation control plane.
        </p>
        <Button variant="primary" onClick={() => navigate("/")}>
          Sign back in
        </Button>
      </div>
    </div>
  );
}
